export const HIDE_FIRST_NAME = 'HIDE_FIRST_NAME';

export const hideFirstName = () => ({type: HIDE_FIRST_NAME});
